<div class="relative">
  <mat-icon
    class="absolute top-1/2 -translate-y-1/2 !text-gray-400 pointer-events-none"
    [class]="size === 'sm' ? 'left-2 !text-[16px] !h-4 !w-4' : 'left-3 !text-[20px] !h-5 !w-5'"
  >search</mat-icon>
  <input
    type="text"
    autocomplete="off"
    class="pp-input w-full border outline-none transition-all text-sm text-gray-900 placeholder:text-gray-400 focus:border-amber-400 focus:ring-2 focus:ring-amber-100"
    [class]="
      (size === 'sm' ? 'pl-7 pr-12 py-2 rounded-lg bg-white ' : 'pl-10 pr-14 py-2.5 rounded-xl bg-gray-50 focus:bg-white ') +
      (isLinked ? 'border-emerald-300' : 'border-gray-200')
    "
    [placeholder]="placeholder"
    [value]="query"
    [title]="query"
    [matAutocomplete]="auto"
    (input)="onInput($any($event.target).value)"
    (focus)="focused.emit()"
    (keyup.enter)="onEnterUp()"
  />
  <div class="absolute right-1.5 top-1/2 -translate-y-1/2 flex items-center gap-0.5">
    @if (isLinked) {
    <mat-icon class="!text-[16px] !h-4 !w-4 !text-emerald-500" title="Linked to a product">check_circle</mat-icon>
    }
    @if (query) {
    <button
      type="button"
      class="h-6 w-6 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center transition-colors"
      aria-label="Clear"
      title="Clear"
      (mousedown)="$event.preventDefault()"
      (click)="clear()"
    >
      <mat-icon class="!text-[16px] !h-4 !w-4">close</mat-icon>
    </button>
    }
  </div>
</div>

<mat-autocomplete
  #auto="matAutocomplete"
  class="pp-panel"
  [panelWidth]="panelWidth"
  [displayWith]="displayWith"
  [autoActiveFirstOption]="autoActiveFirst"
  [hideSingleSelectionIndicator]="true"
  (optionSelected)="onPicked($event.option.value)"
>
  @if (results.length) {
  <div class="pp-header">
    <span>{{ term ? total + ' match' + (total === 1 ? '' : 'es') : suggestions.length ? suggestionsLabel : 'Products' }}</span>
    <span class="pp-hint"><kbd>↑</kbd><kbd>↓</kbd> to move · <kbd>Enter</kbd> to pick · <kbd>Esc</kbd> to close</span>
  </div>
  @for (p of results; track p.productId + '-' + p.productVariantId) {
  <mat-option [value]="p" class="pp-option" [class.pp-option-selected]="p.productId === selectedId">
    <div class="flex items-start gap-3 py-2">
      <div class="min-w-0 flex-1 leading-snug">
        <div class="text-sm font-medium text-gray-900 whitespace-normal">
          @for (seg of segments(p.productName); track $index) {
          <span [class.pp-mark]="seg.match">{{ seg.text }}</span>
          }
        </div>
        @if (p.sku || p.barcode) {
        <div class="mt-1 flex flex-wrap items-center gap-1.5 text-[11px] text-gray-500">
          @if (p.sku) {
          <span class="pp-chip font-mono">
            @for (seg of segments(p.sku); track $index) {
            <span [class.pp-mark]="seg.match">{{ seg.text }}</span>
            }
          </span>
          }
          @if (p.barcode) {
          <span class="inline-flex items-center gap-0.5 text-gray-400">
            <mat-icon class="!text-[13px] !h-[13px] !w-[13px]">qr_code</mat-icon>
            @for (seg of segments(p.barcode); track $index) {
            <span [class.pp-mark]="seg.match">{{ seg.text }}</span>
            }
          </span>
          }
        </div>
        }
      </div>
      @if (showStock) {
      <div class="shrink-0 flex flex-col items-end gap-1 pt-0.5" title="Stock - Kettering / Markstey">
        <span class="pp-stock" [class.pp-stock-none]="totalStock(p) <= 0">{{ totalStock(p) }} in stock</span>
        @if (stockYard) {
        <span class="text-[10px] text-gray-400 whitespace-nowrap">{{ stockYard === 'M' ? 'Markstey' : 'Kettering' }}</span>
        } @else {
        <span class="text-[10px] text-gray-400 whitespace-nowrap">K {{ p.kStockQty ?? 0 }} · M {{ p.mStockQty ?? 0 }}</span>
        }
      </div>
      }
      @if (p.productId === selectedId) {
      <mat-icon class="shrink-0 !text-[18px] !h-[18px] !w-[18px] !text-emerald-500 mt-0.5">check</mat-icon>
      }
    </div>
  </mat-option>
  }
  @if (total > results.length) {
  <div class="pp-footer">Showing {{ results.length }} of {{ total }} - keep typing to narrow it down</div>
  }
  } @else if (term) {
  <!-- A disabled option keeps the panel open to explain the empty result. -->
  <mat-option disabled class="pp-empty-option">
    <div class="pp-empty">
      <mat-icon class="!text-[26px] !h-[26px] !w-[26px] !text-gray-300">search_off</mat-icon>
      <div class="font-semibold text-gray-700 mt-1 whitespace-normal">No product matches "{{ term }}"</div>
      <div class="text-xs text-gray-400 mt-0.5 whitespace-normal">{{ noMatchHint }}</div>
    </div>
  </mat-option>
  }
</mat-autocomplete>
